import React from 'react';
interface HighlightTagProps {
  children: React.ReactNode;
}
export function HighlightTag({
  children
}: HighlightTagProps) {
  return <span className="bg-[#D9F7F4] text-[#00C8B3] px-0.5 rounded" data-id="element-199">
      {children}
    </span>;
}